import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const ScreenRotationIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      {...props}
      color={color}
    >
      <path
        className={classes.elementFill}
        d="M53.214,27.75741a2.0043,2.0043,0,0,0,0-2.8284c-3.196-3.1962-10.946-10.946-14.142-14.1422a2.00187,2.00187,0,0,0-2.83,0c-4.644,4.6444-19.396,19.39719-24.04,24.0416a1.99945,1.99945,0,0,0,0,2.8284C15.398,40.853,23.148,48.60281,26.344,51.799a1.99944,1.99944,0,0,0,2.828,0C33.816,47.1546,48.568,32.4018,53.214,27.75741Zm2.828-2.8284a4.00035,4.00035,0,0,0,0-5.657c-3.14-3.13881-8.176-8.17461-11.314-11.3136a3.99875,3.99875,0,0,0-5.656,0c-6.85,6.849-24.264,24.2636-31.114,31.1126a4.0007,4.0007,0,0,0,0,5.657c3.14,3.13881,8.176,8.1746,11.314,11.3136a3.99876,3.99876,0,0,0,5.656,0C31.778,49.1926,49.192,31.778,56.042,24.929Z"
      />
      <path
        className={classes.element}
        d="M53.214,27.75741a2.0043,2.0043,0,0,0,0-2.8284c-3.196-3.1962-10.946-10.946-14.142-14.1422a2.00187,2.00187,0,0,0-2.83,0c-4.644,4.6444-19.396,19.39719-24.04,24.0416a1.99945,1.99945,0,0,0,0,2.8284C15.398,40.853,23.148,48.60281,26.344,51.799a1.99944,1.99944,0,0,0,2.828,0C33.816,47.1546,48.568,32.4018,53.214,27.75741Zm2.828-2.8284a4.00035,4.00035,0,0,0,0-5.657c-3.14-3.13881-8.176-8.17461-11.314-11.3136a3.99875,3.99875,0,0,0-5.656,0c-6.85,6.849-24.264,24.2636-31.114,31.1126a4.0007,4.0007,0,0,0,0,5.657c3.14,3.13881,8.176,8.1746,11.314,11.3136a3.99876,3.99876,0,0,0,5.656,0C31.778,49.1926,49.192,31.778,56.042,24.929Z"
      />
      <path
        className={classes.element}
        d="M5.04119,33.503Q5.0001,32.7566,5,32A27.01254,27.01254,0,0,1,32,5c.504,0,1.006.01379,1.502.0412L28.544,10"
      />
      <path
        className={classes.element}
        d="M58.958,30.497Q59,31.24342,59,32A27.01254,27.01254,0,0,1,32,59c-.504,0-1.006-.0138-1.502-.04121L35.456,54"
      />
      <line className={classes.element} x1="15.02999" y1="46.1422" x2="17.858" y2="48.9706" />
    </svg>
  );
};

export default ScreenRotationIcon;
